// Cookie consent state — UK PECR compliant.
//
// Returns { consent, accept, reject, isPending } where:
//   consent    — "accepted" | "rejected" | null (null = no choice yet)
//   accept()   — user accepted analytics cookies
//   reject()   — user rejected analytics cookies
//   isPending  — true if user hasn't made a choice yet (show the banner)
//
// Essential cookies (session token, JWT) are NEVER gated behind consent —
// they're required for the service to function and exempt under PECR.
//
// Only analytics / non-essential cookies respect this flag. Before reading
// or writing any analytics storage, check `consent === "accepted"`.

import { useState } from "react";

const STORAGE_KEY = "nomloop_cookie_consent";

function readStored() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === "accepted" || v === "rejected" ? v : null;
  } catch {
    return null;
  }
}

function writeStored(value) {
  try { localStorage.setItem(STORAGE_KEY, value); } catch {}
}

export function useCookieConsent() {
  const [consent, setConsent] = useState(() => readStored());

  const accept = () => { writeStored("accepted"); setConsent("accepted"); };
  const reject = () => { writeStored("rejected"); setConsent("rejected"); };
  const reset  = () => {
    try { localStorage.removeItem(STORAGE_KEY); } catch {}
    // Also clear the session-hidden flag so the user sees the banner again
    // when they choose to change their mind.
    try { sessionStorage.removeItem("nomloop_cookie_banner_hidden"); } catch {}
    setConsent(null);
  };

  return { consent, accept, reject, reset, isPending: consent === null };
}
